// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".begintostart[data-v-2079be2a]{margin-left:.2rem}.van-count-down[data-v-2079be2a]{color:#fff}", ""]);
// Exports
module.exports = exports;
